<template>
    <div class="form-group">
        <slot name="label">
            <label>Status</label>
        </slot>
        <multiselect
            v-model="internalValue"
            :options="getOptions"
            :multiple="true"
            :limit="2"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :placeholder="placeHolder"
            label="name"
            track-by="name"
            select-label="Press click to select"
            deselect-label="Press click to remove"
            :show-labels="false"
            open-direction="below"
            @input="updateValue"
        >
        </multiselect>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    components: {
        Multiselect,
    },
    props: {
        // Define a prop to accept v-model data
        value: {
            type: Array,  // Adjust the type based on the type of value expected (e.g., Array, String, etc.)
            default: () => [],
        },
        //We need to pass options into this format: {"complete":"Complete","removed":"Removed"}
        options: {
            type: Object,
            required: true,
        },
        placeHolder: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            // Use internalValue to manage the value of multiselect internally
            internalValue: this.value,
        };
    },
    computed: {
        getOptions() {
            return this.formatOptions(this.options);
        },
    },
    watch: {
        // Watch for changes from the parent and update internalValue
        value(newVal) {
            if (newVal.length === 0 || newVal[0].value !== undefined) {
                this.internalValue = newVal;
                return;
            }

            //Updating select menu format for pre-selected options
            const selectedOptions = [];
            this.formatOptions(this.options).forEach(optionValue => {
                if (newVal.includes(optionValue.value) && !selectedOptions.includes(optionValue)) {
                    selectedOptions.push(optionValue)
                }
            });
            this.internalValue = selectedOptions;
        },
    },
    methods: {
        formatOptions(options) {
            return Object.entries(options).map(([value, name]) => ({
                name,
                value,
            }))
        },
        // Emit the updated value when changes occur in the multiselect component
        updateValue(value) {
            this.$emit('input', value); // Emit 'input' event to update the v-model
        },
    },
};
</script>

<style lang="scss">
.multiselect,
.multiselect__tags,
.multiselect__single,
.multiselect__option {
    font-size: 12px !important;
}

// fix multiselect weird height when using a placeholder
.multiselect__placeholder {
    display: inline-block !important;
    margin-bottom: 0px !important;
    padding-top: 0px !important;
}

// error class on multiselect
.multiselect.invalid .multiselect__tags {
    border: 1px solid #f86c6b !important;
}

// override default multiselect styles
.multiselect__option--highlight {
    background: #e1e3e9 !important;
    color:#333 !important;
}

.multiselect__option--highlight:after {
    background: none !important;
    font-family: "Font Awesome 5 Free"; /* Ensure this is the correct font family for your version */
    font-weight: 900; /* Font Awesome icons typically use font-weight 900 for solid icons */
    content: "\f058"; /* The content code for the checkmark icon */
    top:-5px;
}

.multiselect__tags {
    padding: 5px !important;
    min-height: 10px;
}

.multiselect__placeholder {
    margin-left: 10px;
    margin-top: 2px;
}

.multiselect__tag {
    background: #f0f0f0 !important;
    border: 1px solid rgba(60, 60, 60, 0.26) !important;
    color: black !important;
    margin-bottom: 0px !important;
    margin-right: 5px !important;
}

.multiselect__tag-icon:after {
    color: rgba(60, 60, 60, 0.5) !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
    background: #f0f0f0 !important;
}

.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
    color: red !important;
}

.multiselect__option.multiselect__option--selected {
    background: none;
}

.multiselect__option.multiselect__option--selected::after {
    font-family: "Font Awesome 5 Free"; /* Ensure this is the correct font family for your version */
    font-weight: 900; /* Font Awesome icons typically use font-weight 900 for solid icons */
    content: "\f00c" !important; /* The content code for the checkmark icon */
    top:-5px;
    color:#333 !important;
}

.multiselect__content-wrapper {
    background: #fff;
}

.multiselect__content {
    background: #fff;
}

.multiselect__option {
    display: block;
    padding: 8px 12px !important;
    min-height: 20px !important;
    line-height: 10px !important;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    white-space: nowrap;
    font-size:12px !important;
}

.multiselect__option:after {
    top: 0;
    right: 0;
    position: absolute;
    line-height: 10px;
    padding-right: 12px;
    padding-left: 20px;
    font-size: 13px;
}

.multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #fff;
    //If we want to allow this to overflow to the x.  Then this causes a problem with the min width
    //width: auto !important;
    //min-width:0.5vw;
    max-height: 240px;
    overflow: visible;
    overflow-y: auto !important;
    overflow-x: visible !important;
    border: 1px solid #e8e8e8;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
}

@media (max-width: 768px) {
    .multiselect__content-wrapper {
        width: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/Utility/CustomOptions/CustomOption.vue